export const labelDefaults = {
  drilldownBackButton: 'Back to Breakdown'
}
